// import HomeWorker from './home.worker'

// const homeWorker = typeof window === 'object' && new HomeWorker()

// export default homeWorker

import { getActiveItems } from '../../dataManipulation/cmsItems'

const filterData = (data, customHome) => {
  const homeData =
    data.homeApi.values[0]?.homeData.filter(
      (r) => r.default === !customHome
    )?.[0]?.home_data ?? []

  const homeDataWithSafeTime = homeData.map((row) => {
    return {
      ...row,
      activeFrom: row.activeFrom ?? 0,
      activeTo: row.activeTo ?? 0,
    }
  })

  return getActiveItems(homeDataWithSafeTime)
}

export default { filterData }
